import { billsApi } from '@/features/bills';
import type { BillListFilters } from '@/features/bills';

/**
 * Download every bill the list filters match as CSV (T20). The API writes the
 * file from all pages, under the caller's location scope — this used to build
 * it in the browser from the one page on screen. Amounts stay in minor units
 * with the currency beside them, so the file is right for any currency.
 */
export async function downloadBillsCsv(filters: BillListFilters): Promise<void> {
  const { blob, filename } = await billsApi.exportCsv(filters);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? 'bills.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
